import { Link } from 'react-router-dom';
import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div`
  flex-grow: 1;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-template: 1fr / 2fr 2fr 3fr 4fr;
  column-gap: 16px;
  padding: 0 24px;
`;

export const Divider = styled.hr`
  width: calc(100% + 48px);
  grid-column: 1 / 5;
  margin: 0 -24px;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.grey003};
`;

export const Header = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 10px 0;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const ItemColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 68px;
`;

export const ItemRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 68px;

  & > * + * {
    margin-inline-start: 6px;
  }
`;

export const ItemLink = styled(Link)`
  text-decoration: none;
`;

export const ItemText = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const ItemSubText = styled(typography.BodyTextTwoRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const ItemBtn = styled(typography.BodyTextTwoRegularTypography)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blueMain};
  border: 0px;
  border-radius: 4px;
  cursor: pointer;

  &:before {
    content: ${({ icon }) => icon};
    font-family: icomoon;
    font-size: 18px;
  }
`;
